import ReportFilterDropdown from "@/reports/components/ReportFilterDropdown";
import { readingLevelFilterContainer } from "./ReadingLevelFilter.style";

interface ReadingLevelFilterProps {
  isClassroomPage?: boolean;
}

const ReadingLevelFilter = (props: ReadingLevelFilterProps) => {
  const { isClassroomPage } = props;
  const gradeLevels = Array.from({ length: 12 }, (_, i) => i + 1);
  const gradeLevelOptions = gradeLevels
    ?.map((gradeLevel: number) => {
      // eslint-disable-next-line array-callback-return
      if (gradeLevel <= 1) return;
      if (gradeLevel === 2) {
        return {
          value: `${gradeLevel}`,
          label: "2nd grade and lower",
        };
      }

      return {
        value: `${gradeLevel}`,
        label: `${gradeLevel}${gradeLevel === 3 ? "rd" : "th"} grade`,
      };
    })
    .sort(() => -1);

  const defaultOption = { value: "", label: "All reading levels" };
  const menuOptions = gradeLevelOptions
    ? [defaultOption, ...gradeLevelOptions]
    : [];
  const filteredMenuOptions = menuOptions.filter(
    (gradeLevel) => gradeLevel !== undefined,
  ) as Array<{ value: string; label: string }>;
  const eventTrackingDescription = `Teacher Reporting - ${isClassroomPage ? "classroom" : "student"} reading skills - grade level filter`;

  return (
    <div css={readingLevelFilterContainer}>
      <ReportFilterDropdown
        menuOptions={filteredMenuOptions}
        defaultOption={defaultOption}
        label="Reading level"
        urlSearchParam="reading_level"
        eventTrackingDescription={eventTrackingDescription}
      />
    </div>
  );
};

export default ReadingLevelFilter;
